import { render } from "./DescriptionView.vue?vue&type=template&id=2b322600&scoped=true"
import script from "./DescriptionView.vue?vue&type=script&lang=js"
export * from "./DescriptionView.vue?vue&type=script&lang=js"

import "./DescriptionView.vue?vue&type=style&index=0&id=2b322600&lang=css"
import "./DescriptionView.vue?vue&type=style&index=1&id=2b322600&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b322600"]])

export default __exports__